import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useFKspListQuery } from '../../store/DianShangYeWuApi';
import CostNodeCheckApprove from './CostNodeCheckApprove';
import CostNodeCheckEdit from './CostNodeCheckEdit';
function CostNodeCheck(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useFKspListQuery({ddzc_sp_ddzc_id:props.ddzc_id},{skip:!props.ddzc_id})
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            // 然后 map，判断是否是最后一个元素
            const newArr =  data.Result.map(item => {
                const {
                    ddzc_sp_jd_name,
                    ddzc_sp_yh_name,
                    ddzc_sp_yh_id,
                    ddzc_sp_jd_xuhao,
                    ddzc_sp_content,
                    ddzc_sp_id,
                    ddzc_sp_dsbzd_id,
                    ddzc_sp_dsbzd_name,
                    ddzc_sp_state,
                    ddzc_sp_state_time,
                    ddzc_sp_uname,
                    ddzc_sp_ctime,
                    ddzc_sp_dsbzd_date,
                    ddzc_sp_dsbzd_date_end,
                    ddzc_sp_dsbzd_kh_id,
                    ddzc_sp_dsbzd_kh_name,
                } = item;
                return {
                    ddzc_sp_jd_name,
                    ddzc_sp_yh_name,
                    ddzc_sp_yh_id,
                    ddzc_sp_jd_xuhao,
                    ddzc_sp_content,
                    ddzc_sp_id,
                    ddzc_sp_dsbzd_id,
                    ddzc_sp_dsbzd_name,
                    ddzc_sp_state,
                    ddzc_sp_state_time,
                    ddzc_sp_uname,
                    ddzc_sp_ctime,
                    ddzc_sp_dsbzd_date,
                    ddzc_sp_dsbzd_date_end,
                    ddzc_sp_dsbzd_kh_id,
                    ddzc_sp_dsbzd_kh_name,
                }                
            })
            // 排序数据
            const sortedData = newArr.sort((a, b) => {
                return a.ddzc_sp_jd_xuhao - b.ddzc_sp_jd_xuhao;
            });
            // 生成 arr 并计算 current
            let firstApproveWithState2Index = -1; // 在 arr 中的索引（状态为 '2' 的审批点）
            let lastItemIndex = -1; // 在 arr 中的最后一个 item 的索引
            let arrIndex = 0; // arr 的当前索引
            
            const arr = sortedData.map((item) => {
                let result = null;
                if(item.ddzc_sp_jd_name === '审批' && item.ddzc_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddzc_sp_yh_name}</span>,
                        ddzc_sp_state:item.ddzc_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddzc_sp_jd_name === '审批' && item.ddzc_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.ddzc_sp_yh_id ? <CostNodeCheckApprove 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        ddzc_id={props.ddzc_id}
                                                                        ddzc_date={props.ddzc_date}
                                                                        ddzc_kh_id={props.ddzc_kh_id}
                                                                        ddzc_kh_name={props.ddzc_kh_name}
                                                                        ddzc_sp_id={item.ddzc_sp_id}
                                                                        ddzc_sp_jd_xuhao={item.ddzc_sp_jd_xuhao}
                                                                        ddzc_sp_jd_name={item.ddzc_sp_jd_name}
                                                                        ddzc_sp_yh_id={item.ddzc_sp_yh_id}
                                                                        ddzc_sp_yh_name={item.ddzc_sp_yh_name}
                                                                        ddzc_sp_uid={item.ddzc_sp_uid}
                                                                        ddzc_sp_uname={item.ddzc_sp_uname}
                                                                    /> : <span style={{fontSize:"12px"}}>{item.ddzc_sp_yh_name}</span>,
                        ddzc_sp_state:item.ddzc_sp_state,
                                                                    
                    }
                    // 找到第一个状态为 '2' 的审批点
                    if(firstApproveWithState2Index === -1){
                        firstApproveWithState2Index = arrIndex;
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddzc_sp_jd_name === '审批' && (item.ddzc_sp_state==='3' || item.ddzc_sp_state==='4' || item.ddzc_sp_state==='5')){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.ddzc_sp_yh_id ? <CostNodeCheckEdit 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        ddzc_id={props.ddzc_id}
                                                                        ddzc_date={props.ddzc_date}
                                                                        ddzc_kh_id={props.ddzc_kh_id}
                                                                        ddzc_kh_name={props.ddzc_kh_name}
                                                                        ddzc_sp_id={item.ddzc_sp_id}
                                                                        ddzc_sp_jd_xuhao={item.ddzc_sp_jd_xuhao}
                                                                        ddzc_sp_jd_name={item.ddzc_sp_jd_name}
                                                                        ddzc_sp_yh_id={item.ddzc_sp_yh_id}
                                                                        ddzc_sp_yh_name={item.ddzc_sp_yh_name}
                                                                        ddzc_sp_uid={item.ddzc_sp_uid}
                                                                        ddzc_sp_uname={item.ddzc_sp_uname}
                                                                        ddzc_sp_state={item.ddzc_sp_state}
                                                                        ddzc_sp_state_time={item.ddzc_sp_state_time}
                                                                        ddzc_sp_content={item.ddzc_sp_content}
                                                                    />: <Space orientation='vertical' size={0}>
                                                                            <span style={{color:item.ddzc_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                                                                                {item.ddzc_sp_state==='4' ? '驳回' : '同意'}
                                                                                {item.ddzc_sp_content? '：'+item.ddzc_sp_content :''}
                                                                            </span>
                                                                            <span>{item.ddzc_sp_yh_name} {item.ddzc_sp_state_time} </span>
                                                                        </Space>,
                                                                        ddzc_sp_state:item.ddzc_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddzc_sp_jd_name === '抄送' && item.ddzc_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddzc_sp_yh_name}</span>,
                        ddzc_sp_state:item.ddzc_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddzc_sp_jd_name === '抄送' && item.ddzc_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddzc_sp_yh_name}</span>,
                        ddzc_sp_state:item.ddzc_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddzc_sp_jd_name === '抄送' && item.ddzc_sp_state==='3'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddzc_sp_yh_name} {item.ddzc_sp_state_time}</span>,
                        ddzc_sp_state:item.ddzc_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                return result;
            })
            
            // 计算 current，规则优先级：'2' > '4' > 最后一个
            let calculatedCurrent = 0;
            let firstApproveWithState4Index = -1;

            // 查找 '2' 和 '4' 的索引
            arr.forEach((item, idx) => {
                if (item && item.ddzc_sp_state === '2' && firstApproveWithState2Index === -1) {
                    firstApproveWithState2Index = idx;
                }
                if (item && item.ddzc_sp_state === '4' && firstApproveWithState4Index === -1) {
                    firstApproveWithState4Index = idx;
                }
            });

            if (firstApproveWithState2Index !== -1) {
                calculatedCurrent = firstApproveWithState2Index;
            } else if (firstApproveWithState4Index !== -1) {
                calculatedCurrent = firstApproveWithState4Index;
            } else if (lastItemIndex !== -1) {
                calculatedCurrent = lastItemIndex;
            }

            // current 需要加上前面的"创建"和"提交"两个步骤
            setCurrent(calculatedCurrent + 2);
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"14px"}}>{props.ddzc_uname} {props.ddzc_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"14px"}}>{props.ddzc_uname} {props.ddzc_state_time}</span>,
            },...arr]);
        }else{
            setItems([]);
        }
        
        
    },[data, isSuccess,props.ddzc_id,props.ddzc_uname,props.ddzc_ctime,props.ddzc_state_time,props.ddzc_date,props.ddzc_kh_id,props.ddzc_kh_name,props.yh_id,props.yh_name])
    return (
        <Steps 
            items={items} 
            current={current} 
            size="small" 
            titlePlacement="vertical" 
        />
    )
}

export default CostNodeCheck